import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ProductSelector } from 'moet-core';

import { AlertBlockWarning, SpacerVertical } from '@klarna/bubble-ui';

import { ProductSelectionOneKlarnaWrapper } from '@/components/ProductSelectionOneKlarnaWrapper';
import { getMerchantAwareArrayTranslator, getMerchantPlatformId } from '@/selectors/merchant';
import { isKlarnaOneAvailable } from '@/selectors/products';
import { getSelectedPlatformKey } from '@/selectors/data';

const ProductSelectionWrapperComponent = ({
  t,
  tArray,
  onChange,
  country,
  platform,
  products,
  isAddingProducts,
  isSelectedFn,
  isInstalledFn,
  isKlarnaOne,
  extraAttributesToProductFn,
  shouldShowExpandedProductCard,
}) => {
  const platformAlert = tArray(`products-fe.containers.select_products.platform_alert.${platform}`);
  const productSelector = isKlarnaOne ? (
    <ProductSelectionOneKlarnaWrapper
      products={products}
      extraAttributesToProductFn={extraAttributesToProductFn}
      isAddingProducts={isAddingProducts}
      isInstalledFn={isInstalledFn}
      isSelectedFn={isSelectedFn}
      onChange={onChange}
      shouldShowExpandedProductCard={shouldShowExpandedProductCard}
      t={t}
    />
  ) : (
    <ProductSelector
      t={t}
      onChange={onChange}
      country={country}
      products={products.filter(p => !p.id.includes('one'))}
      isAddingProducts={isAddingProducts}
      isKlarnaOneAvailable={isKlarnaOneAvailable}
      isSelectedFn={isSelectedFn}
      isInstalledFn={isInstalledFn}
      extraAttributesToProductFn={extraAttributesToProductFn}
    />
  );

  return (
    <>
      {platformAlert ? (
        <>
          <AlertBlockWarning
            content={
              Array.isArray(platformAlert) ? platformAlert.map(s => s.text) : [platformAlert]
            }
          />
          <SpacerVertical spaceToken="space/600" />
        </>
      ) : null}
      {productSelector}
    </>
  );
};

ProductSelectionWrapperComponent.propTypes = {
  extraAttributesToProductFn: PropTypes.func.isRequired,
  isKlarnaOne: PropTypes.bool.isRequired,
  isSelectedFn: PropTypes.func.isRequired,
  platform: PropTypes.string.isRequired,
  shouldShowExpandedProductCard: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  tArray: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  country: PropTypes.string,
  isAddingProducts: PropTypes.bool,
  isInstalledFn: PropTypes.func,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ),
};

export const ProductSelectionWrapper = connect(state => ({
  isKlarnaOneAvailable: isKlarnaOneAvailable(state),
  platform: getSelectedPlatformKey(state) || getMerchantPlatformId(state),
  tArray: getMerchantAwareArrayTranslator(state),
}))(ProductSelectionWrapperComponent);
